import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { getData, putData } from '../Services/api'

const RouteEdit = () => {
  const { id } = useParams();
  const [users, setUsers] = useState([]);
  const [values, setValues] = useState({ route_name: "", user_ids: [] });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchUsers = async () => {
    try {
      const res = await getData(`/users/salesperson-admin`);
      if (res.success) setUsers(res.data || [])
    } catch (error) {
      console.log("error fetch users", error)
    }
  }

  const fetchRoute = async () => {
    try {
      const res = await getData(`/routes/${id}`);
      if (res.status) {
        setValues({
          route_name: res.data.route_name || "",
          user_ids: res.data.user_ids || []
        });
      }
    } catch (error) {
      console.log("error fetch route", error)
    }
  }

  useEffect(() => {
    fetchUsers();
    fetchRoute();
  }, [id])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  }

  const handleCheckboxChange = (uid) => {
    setValues(prev => {
      const isSelected = prev.user_ids.includes(uid);
      return {
        ...prev,
        user_ids: isSelected
          ? prev.user_ids.filter(id => id !== uid)
          : [...prev.user_ids, uid]
      }
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await putData(`/routes/update/${id}`, values);
      if (res.status) {
        toast.success(res.message || 'Route updated successfully');
        navigate('/routes/route-list');
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log("error route update", error)
      toast.error(error.response?.data?.message || 'error')
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="page-header">
          <div className="page-block">
            <ul className="breadcrumb">
              <li className="breadcrumb-item"><Link to="/">Home</Link></li>
              <li className="breadcrumb-item"><Link to="/routes/route-list">Routes</Link></li>
              <li className="breadcrumb-item">Edit Route</li>
            </ul>
          </div>
        </div>

        <div className="card">
          <div className="card-header"><h5>Edit Route</h5></div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Route Name</label>
                <input type="text" className="form-control"
                  name="route_name" value={values.route_name}
                  onChange={handleChange} required />
              </div>

             <div className="col-md-12 mt-3">
  <label className="form-label">Assign Salespersons</label>
  <ul className="list-group" style={{ maxHeight: '300px', overflowY: 'auto' }}>
    {users.length > 0 ? users.map(user => (
      <li key={user.id} className="list-group-item d-flex align-items-center">
        <input
          type="checkbox"
          className="form-check-input me-2"
          id={`user-${user.id}`}
          checked={values.user_ids.includes(user.id)}
          onChange={() => handleCheckboxChange(user.id)}
        />
        <label className="form-check-label mb-0" htmlFor={`user-${user.id}`}>
          {user.username} ({user.email})
        </label>
      </li>
    )) : (
      <li className="list-group-item text-muted">No salespersons available.</li>
    )}
  </ul>
</div>

              <div className="text-end mt-4">
                <Link to="/routes/route-list" className="btn btn-outline-secondary">Cancel</Link>
                <button className="btn btn-primary" type="submit" disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </form>
          </div>
        </div>

      </div>
    </div>
  )
}

export default RouteEdit
